<template>
    <div class="main_center" style="margin: 0px 0px; padding-top: 8px;">
        <PmSearch ref="searchRef"
                  :form.sync="form"
                  :options.sync="searchConfigs"
                  label-width="98px"
                  @reset="resetSearch"
                  @search="seachBtn">
            <template v-slot:purchaseItemSlot="purchaseItemSlot">
                <div class="multiple-item-wrap">
                    <el-select v-model="form.purchaseItemId" filterable :filter-method="filterOption" placeholder="请选择" style="width: 100%">
                        <el-option-group
                                style="width: 100%"
                                v-for="group in purchaseCatalogList"
                                :key="group.label"
                                :label="group.label">
                            <el-option
                                    v-for="item in group.options"
                                    style="width: 100%"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.id">
                                <span style="float: right">{{ item.name }}</span>
                                <span style="float: left; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                            </el-option>
                        </el-option-group>
                    </el-select>
                </div>
            </template>
            <template v-slot:afterSearchComSlot>
                <el-col  :span="18" style="padding-bottom: 16px">
                    <el-button size="small"  icon="el-icon-plus" type="primary"
                               @click="routerGo('')">新增</el-button>
                    <el-button size="small" type="danger" plain icon="el-icon-delete"
                               @click="deleteSelectItem()">删除
                    </el-button>
                </el-col>
            </template>
        </PmSearch>
        <div class="content">
            <el-table
                    :data="tableData"
                    v-loading="dataListLoading"
                    ref="multipleTable"
                    :height="tableMaxHeight"
                    stripe
                    border
                    @selection-change="handleSelectionChange"
            >
                <el-table-column
                        fixed
                        label="序号"
                        type="index"
                        :index="indexMethod"
                        width="50"
                        align="center"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column fixed type="selection" align="center"
                                 :show-overflow-tooltip='true'></el-table-column>
                <el-table-column label="操作" align="left" width="180" fixed="right">
                    <template slot-scope="scope">
                        <el-button
                                type="text"
                                size="small"
                                title="编辑"
                                @click="routerGo(scope.row)">编辑</el-button>
                        <el-button
                                type="text"
                                size="small"
                                title="删除" @click="deleteById(scope.row)">删除</el-button>
                        <el-button
                                type="text"
                                size="small"
                                :title="scope.row.isShow?'隐藏':'显示'"
                                @click.stop="changeIsShow(scope.row)">{{scope.row.isShow?'隐藏':'显示'}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                        label="政策法规文件"
                        prop="title"
                        align="left"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        label="发布时间"
                        prop="releaseTime"
                        align="left"
                        min-width="180"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        label="修改人"
                        prop="updateUser"
                        header-align="left"
                        align="left"
                        width="150"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        label="修改时间"
                        prop="updateTime"
                        header-align="left"
                        align="left"
                        width="180"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        label="创建人"
                        prop="createUser"
                        header-align="left"
                        align="left"
                        width="150"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        label="创建时间"
                        prop="createTime"
                        header-align="left"
                        align="left"
                        width="180"
                        :show-overflow-tooltip="true"
                ></el-table-column>
            </el-table>
            <pagination
                    class="limit"
                    :page-sizes="[10, 20, 50, 100]"
                    :total="total"
                    :page.sync="pageIndex"
                    :limit.sync="pageSize"
                    @pagination="paginationChange"
            ></pagination>
        </div>
    </div>
</template>

<script>
    import Pagination from "@/components/Pagination.vue";
    import PmSearch from "@/components/PmSearch/index.vue";
    import {removeTabHandle} from "@/utils/routeTab";
    import {httpMixinsCommonPost, httpMixinsList, httpSysPurcatalogList} from "@/server/purchase";
    export default {
        name: "busWitnessTable",
        components: {
            PmSearch,
            Pagination,
        },
        data() {
            return {
                tableMaxHeight: document.documentElement.clientHeight - 275,
                dataListLoading: false,
                form: {},
                diaTitle:'',
                visible:false,
                dataForm:{},
                tableData:[],
                purchaseCatalogList:[],
                purchaseCatalogListCopy:[],
                searchConfigs:[
                    {
                        type:'input',
                        key:'title',
                        label:'政策法规文件',
                        isShow:true
                    },
                ],
            };
        },
        filters: {
            ellipsis(text, num) {
                if (text.length > num) {
                    return text.substring(0, num) + "...";
                } else {
                    return text;
                }
            }
        },
        activated() {
            this.getDataList();
        },
        created() {

            httpSysPurcatalogList({}).then((res) => {
                this.purchaseCatalogList = res.data;
                this.purchaseCatalogListCopy = JSON.parse(JSON.stringify(res.data));
            })
        },
        mounted() {
            const that = this;
            let resizeTag = true;
            window.onresize = () => {
                if (resizeTag) {
                    //防抖动
                    that.ifmove();
                    resizeTag = false;
                    setTimeout(() => {
                        resizeTag = true;
                    }, 1000);
                }
            };
            that.ifmove();
        },
        computed: {},

        methods: {
            filterOption(query) {
                this.purchaseCatalogList = JSON.parse(JSON.stringify(this.purchaseCatalogListCopy));
                this.purchaseCatalogList.forEach(group => {
                    group.options = group.options.filter(option =>
                        option.name.toLowerCase().includes(query.toLowerCase()) || option.value.toLowerCase().includes(query.toLowerCase())
                    );
                });
            },
            changeIsShow(row){
                httpMixinsCommonPost('/purchase/policiesRegulations/updateShow', {
                    id: row.id,
                    isShow:row.isShow?0:1
                }).then(res => {
                    if (res.data.code == '1') {
                        this.$message({
                            type: 'success',
                            message: res.data.msg
                        })
                        this.getDataList();
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                })
            },
            ifmove() {
                let tableMaxHeight = document.documentElement.clientHeight - 328;
                this.pageSize = parseInt(tableMaxHeight / 50) || 1;
                this.$nextTick(() => {
                    this.tableMaxHeight = tableMaxHeight;
                });
                // this.getDataList()
            },
            getDataList() {
                // 获取列表数据
                this.dataListLoading = true;
                httpMixinsList("/purchase/policiesRegulations/pagedList", {
                    page: this.pageIndex,
                    rows: this.pageSize,
                    filter: {
                        purchaser:false,
                        ...this.form
                    }
                })
                    .then((data) => {
                        this.dataListLoading = false;
                        if (data) {
                            this.tableData = data.data.rows || [];
                            this.total = data.data.total || 0;
                            this.$refs.multipleTable.doLayout();
                        }
                    });
            },

            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            paginationChange(obj) {
                this.pageIndex = obj.page || 1;
                this.pageSize = obj.limit || 5;
                this.getDataList();
            },

            indexMethod(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1;
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            resetSearch(){
                this.form.purchaseItemId = '';
            },
            //搜索按钮
            seachBtn() {
                this.pageIndex = 1;
                this.getDataList();
            },
            routerGo(item){ // 跳转详情
                removeTabHandle('lawfileDetail')
                var id = item && item.id || '';
                this.$router.push({
                    name:'lawfileDetail',
                    query:{
                        id:id
                    }
                })
            },
            deleteById(item) {
                this.$confirm(`确定要删除该数据?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    httpMixinsCommonPost('/purchase/policiesRegulations/delete', {
                        id: item.id
                    }).then(res => {
                        if (res.data.code == '1') {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            })
                            this.getDataList();
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.msg
                            })
                        }
                    })
                })
            },
            deleteSelectItem() {
                let ids = new Array();
                this.multipleSelection.forEach(key => {
                    ids.push(key.id)
                })

                if (ids != "" || ids.length > 0) {

                    this.$confirm(`确定要删除所选数据?`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        httpMixinsCommonPost('/purchase/policiesRegulations/delete', {
                            idList: ids
                        }).then(res => {
                            if (res.data.code == '1') {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                })
                                this.getDataList();
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: res.data.msg
                                })
                            }
                        })
                    })


                } else {
                    this.$message({
                        type: 'error',
                        message: "未选择删除项。"
                    })
                }

            },

        },

        destroyed() {
            window.onresize = null;
        }
    };
</script>
<style lang="less" scoped>

</style>
